module.exports = __webpack_public_path__ + "static/media/mock-up2.2c1608d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/mock-up2.png
// module id = 507
// module chunks = 0